import React from 'react'
import Container from '@material-ui/core/Container'
import {makeStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import Box from '@material-ui/core/Box'
import { borderTop } from '@material-ui/system'

const useStyles = makeStyles((theme)=>({
    footer: {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing(8),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6),
        },
    },
}));

function Copyright() {
    return (
        <Typography variant='body2' color='textSecondary' align='center'>
            {'Copyright © '}
            <Link color='inherit' href='https://material-ui.com/'>
                Javokhirbek's Blog
            </Link> {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    )
}

const footers = [
    // {
    //   title: 'Company',
    //   description: ['Team', 'History', 'Contact us', 'Locations'],
    // },
    // {
    //   title: 'Features',
    //   description: ['Cool stuff', 'Random feature', 'Team feature', 'Developer stuff', 'Another one'],
    // },
    // {
    //   title: 'Resources',
    //   description: ['Resource', 'Resource name', 'Another resource', 'Final resource'],
    // },
    // {
    //   title: 'Legal',
    //   description: ['Privacy policy', 'Terms of use'],
    // },
  ];
  
const Footer = () => {
    const classes = useStyles();
    return (
        <React.Fragment>
    <Container maxWidth="md" component="footer" className={classes.footer}>
        <Grid container spacing={4} justifyContent="space-evenly">
          {footers.map((footer) => (
            <Grid item xs={6} sm={3} key={footer.title}>
              <Typography variant="h6" color="textPrimary" gutterBottom>
                {footer.title}
              </Typography>
              <ul>
                {footer.description.map((item) => (
                  <li key={item}>
                    <Link href="#" variant="subtitle1" color="textSecondary">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </Grid>
          ))}
        </Grid>
        <Box mt={5}>
          <Copyright />
        </Box>
      </Container>
      </React.Fragment>
    )}

export default Footer;